import React, { useEffect, useState } from "react";
import SignUp from "../component/SignUp";
import { useNavigate } from "react-router-dom";

interface SignUpData {
  name: string;
  password: string;
  confirmPassword: string;
  number: string;
  address: string;
  companyName: string;
  vatNumber: string;
}
const SignupScreen = () => {
  const navigate = useNavigate();
  const [isIos, setIsIos] = useState(false);
  useEffect(() => {
    if (localStorage.getItem("ios") === "true") {
      setIsIos(true);
    } else {
      const params = new URLSearchParams(window.location.search);
      const Os = params.get("appauth");
      if (Os === "true") {
        localStorage.setItem("ios", "true");
        setIsIos(true);
      } else {
        setIsIos(false);
      }
    }
  }, []);

  const onSignUpPressed = (signupData: SignUpData) => {
    navigate("/forgotpassword", { state: { signupData: signupData } });
  };

  return <SignUp onSignUpPressed={onSignUpPressed} isIos={isIos} />;
};

export default SignupScreen;
